/* eslint-disable no-console */
import {Button, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {
	Wrapper,
	CameraFrame,
	OverlaySvg,
	FaceEllipse,
	VideoStyled,
	HintText,
	StyledImage,
} from './styles';
import Icon from 'presentation/icons';
import {useFaceDetection} from './hooks/useFaceDetection';
import {ResponsiveCard} from '../ResponsiveCard';
import {FacialBiometricsHeader} from '../FacialBiometricsHeader';
import {useMediaQueries} from 'presentation/pages/private';
import {CTAButtonFixed} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import IconNamesType from 'presentation/icons/IconNamesType';
import {STEP_CONFIG} from '../../constants/photo-step-config';

const {
	facePhoto: {
		faceCamera: {hint1, hint2, primaryButton, secondaryButton, allSet},
	},
} = translations['pt-br'].others.facialBiometric;

export function FaceCamera() {
	const {palette} = useTheme();
	const {isTablet} = useMediaQueries();

	const {videoRef, faceDetected, message, photo, retakePhoto, nextStep, step} =
		useFaceDetection();

	return (
		<>
			<FacialBiometricsHeader variant="white" />

			<Stack alignItems="center" height="100%">
				<ResponsiveCard>
					<Stack
						alignItems="center"
						justifyContent="center"
						height="100%"
						flexDirection="column"
						gap={3}>
						<Stack>
							<Stack alignItems="center">
								<Icon
									name={
										photo
											? 'check-circle-outline-filled'
											: (STEP_CONFIG[step].icon as IconNamesType)
									}
									color={photo ? palette.success.main : palette.primary.main}
									size={40}
								/>

								<Typography
									variant="h6"
									color="primary"
									sx={{mb: -2}}
									textAlign="center">
									{photo ? allSet : message}
								</Typography>
							</Stack>

							<Wrapper>
								<CameraFrame>
									<OverlaySvg viewBox="0 0 320 384">
										<FaceEllipse
											cx="160"
											cy="192"
											rx="116.5"
											ry="155.5"
											detected={faceDetected || !!photo}
										/>
									</OverlaySvg>

									{photo ? (
										<StyledImage src={photo} alt="Preview" />
									) : (
										<VideoStyled
											ref={videoRef}
											autoPlay
											muted
											playsInline
											width={320}
											height={384}
										/>
									)}
								</CameraFrame>

								{!faceDetected && !photo && <HintText>{hint1}</HintText>}
								{photo && <HintText>{hint2}</HintText>}
							</Wrapper>

							{photo && !isTablet && (
								<Stack direction="row" gap={1} mt={2}>
									<Button sx={{mt: 2}} onClick={retakePhoto} variant="outlined">
										{secondaryButton}
									</Button>
									<Button sx={{mt: 2}} onClick={nextStep}>
										{primaryButton}
									</Button>
								</Stack>
							)}
						</Stack>
					</Stack>
				</ResponsiveCard>

				{photo && isTablet && (
					<CTAButtonFixed.Root $isTablet={isTablet} sx={{bottom: 0}}>
						<CTAButtonFixed.Action onClick={nextStep} fullWidth>
							{primaryButton}
						</CTAButtonFixed.Action>
						<CTAButtonFixed.Action onClick={retakePhoto} variant="outlined" fullWidth>
							{secondaryButton}
						</CTAButtonFixed.Action>
					</CTAButtonFixed.Root>
				)}
			</Stack>
		</>
	);
}
